import {
  useAwaitQuery 
} from "./useAwaitQuery";

export {
  useAwaitQuery 
};
